export default __webpack_public_path__ + "static/media/gallery_06.6c0f4485.jpg";